import type { IconSvgObject } from './types';

const HistoryIcon: IconSvgObject = [
  ["path", { d: "M3.32619 11.3047C4.32619 8.30469 7.90751 5.30469 11.8262 5.30469C16.7967 5.30469 20.8262 9.33412 20.8262 14.3047C20.8262 19.2753 16.7967 23.3047 11.8262 23.3047C7.89465 23.3047 4.55192 20.7838 3.32619 17.2702", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M7.32619 11.3047H2.82619V6.30469", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M11.8262 9.30469V14.3047L14.8262 16.3047", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default HistoryIcon;
